import { IonButton, IonButtons, IonCard, IonCardContent, IonCheckbox, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonInputPasswordToggle, IonItem, IonModal, IonNote, IonPage, IonRow, IonSpinner, IonText, IonTitle, IonToolbar, useIonLoading, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewDidLeave, useIonViewWillEnter, useIonViewWillLeave } from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react';
import { chevronBackOutline, eyeOffOutline, eyeOutline, logInOutline, personCircleOutline } from 'ionicons/icons';
import { Link, Prompt } from 'react-router-dom';
import { useAppContext } from '../AppProvider';

const Register: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [passcodeVisible, setPasscodeVisible] = useState<boolean>(false);
    const [disableSubmit, setDisableSubmit] = useState<boolean>(true);
    const [modalContent, setModalContent] = useState<any>(null);
    const [present, dismiss] = useIonLoading();
    const [isOpen, setIsOpen] = useState(false);

    const { networkStatus, authenticateMember, settings, setAuthKey, setActivePartners, setAuthorizedMember, setAvailableContacts, setAvailableKids, setAvailablePets, setCheckedContacts, setContacts, setKids, setPendingPartners, setPets, setPlaces, setRoutes, setSelectedVehiclesEnd, setSelectedVehiclesEnroute, setSelectedVehiclesStart, setSettings, setStartPlaces, setUserTimezone, setVehicles, setVehiclesAll, setVehiclesEnd, setVehiclesEnroute, setVehiclesStart, textLogoLoaded, fadeInTextLogo, SWFullHorizLogo } = useAppContext();
    
    const [showToast] = useIonToast();
    const router = useIonRouter();

    const fnameInput = useRef<any>();
    const lnameInput = useRef<any>();
    const emailInput = useRef<any>();
    const passcodeInput = useRef<any>();
    const signupBtn = useRef<HTMLIonButtonElement>(null);

    useIonViewWillEnter(() => {
        document.body.classList.remove('dark');
    });

    //
    // Authenticate Member
    //
    useIonViewDidEnter(() => { 
        const authenticate = async () => {
            const authenticated = await authenticateMember();   
            if (!authenticated || authenticated.mt == '') {
                validateForm();
                setLoading(false); 
            } else {
                if (networkStatus) router.push('/account/dashboard', 'forward');
            }
        };
        authenticate();
    }); 


    /*useIonViewWillLeave(() => {
        setIsOpen(false); 
        setSwipeEnabled(true);
        passcodeInput.current.value = '';
        setPasscodeVisible(false);
        setDisableSubmit(true);
    });*/


    //
    // Reset the form upon leaving page
    //
    /*useIonViewDidLeave(() => {
        fnameInput.current.value = '';
        lnameInput.current.value = '';
        emailInput.current.value = '';
        passcodeInput.current.value = '';
        setPasscodeVisible(false);
        setDisableSubmit(true);
    });*/

    //
    // Validate Form
    //
    const validateForm = () => {
        //const el = e.target; 
        const fname = fnameInput.current.value;
        const lname = lnameInput.current.value;
        const email = emailInput.current.value;
        const passcode = passcodeInput.current.value;
        const disable = (fname.length < 2 ||
                          lname.length < 2 ||
                          email.length < 6 ||
                          !email.includes('@') || 
                          !email.includes('.') || 
                          email.indexOf('@') > email.lastIndexOf('.') ||
                          (email.match(/@/g)).length > 1 ||
                          passcode.length < 8);
        if (signupBtn.current !== null) {
            signupBtn.current.disabled = disable;
            signupBtn.current.color = disable ? 'primary' : 'secondary';
        }
    };

    //
    // Submit Registration
    //
    const submitRegistration = async (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        await present('Creating your account...');

        setAuthKey({});
        setActivePartners({});
        setAuthorizedMember({});
        setAvailableContacts({});
        setAvailableKids({});
        setAvailablePets({});
        setCheckedContacts({});
        setContacts({});
        setKids({});
        setPendingPartners({});
        setPets({});
        setPlaces({});
        setRoutes({});
        setSelectedVehiclesEnd({});
        setSelectedVehiclesEnroute({});
        setSelectedVehiclesStart({});
        setSettings({});
        setStartPlaces({});
        setUserTimezone({});
        setVehicles({});
        setVehiclesAll({});
        setVehiclesEnd({});
        setVehiclesEnroute({});
        setVehiclesStart({});

        try {
            const form = e.target; 
            const formData = new FormData(form);
            const response = await fetch('https://api.besolowise.com/members/register/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success && obj.mt != false) {
                    fnameInput.current.value = '';
                    lnameInput.current.value = '';
                    emailInput.current.value = '';
                    passcodeInput.current.value = '';
                    setPasscodeVisible(false);
                    setDisableSubmit(true);
                    setTimeout(() => {
                        router.push('/welcome/'+obj.mt, 'forward');
                        dismiss();
                    }, 2000);
                } else {
                    dismiss();
                    showToast({
                        message: 'Registration Error: ' + obj.message,
                        duration: 4000,
                        color: 'danger',
                        position: 'middle'
                    });
                    emailInput.current.value = '';
                }

            } else {
                dismiss();
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 2000,
                    color: 'danger',
                    position: 'middle'
                });  
            }   

        } catch(error) {
            dismiss();
            showToast({
                message: 'Connection: ' + error + '.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        } 
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar className='ion-text-center'>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerLink='/'><IonIcon icon={chevronBackOutline}></IonIcon> </IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonButton color={'tertiary'} routerLink='/login'>Log In</IonButton>                        
                    </IonButtons>                    
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding home-content-bg-1">
                <div className='ion-padding-bottom'>
                    <h1 className='ion-text-center'>Create Your Free Account</h1>
                </div>
                <IonGrid fixed>
                    <IonRow class='ion-justify-content-center'>
                        <IonCol size='12' sizeMd='8' sizeLg='6' sizeXl='4'>
                            <IonCard className='ion-padding'>
                                <IonCardContent>
                                    <form className='ion-margin-top' onSubmit={submitRegistration}>
                                        
                                        <IonInput fill='outline' name='joinFirstName' label='First name' labelPlacement='stacked' onKeyUp={validateForm} ref={fnameInput} type='text' autocapitalize='sentences'></IonInput>

                                        <IonInput className='ion-margin-top' fill='outline' name='joinLastName' label='Last name' labelPlacement='stacked' onKeyUp={validateForm} ref={lnameInput} type='text' autocapitalize='on'></IonInput>

                                        <IonInput className='ion-margin-bottom ion-margin-top' fill='outline' label='Email address' labelPlacement='stacked' name='joinUsername' onKeyUp={validateForm} ref={emailInput} type='email'></IonInput>

                                        <IonNote>Your account passcode must be at least 8 characters and should include a combination of letters (lower and upper case), numbers, and other standard keyboard characters.</IonNote>
                                        
                                        <IonInput className='ion-margin-bottom ion-margin-top' fill='outline' label='Set your passcode' labelPlacement='stacked' name='joinPasscode' onKeyUp={validateForm} ref={passcodeInput} type='password'>
                                            <IonInputPasswordToggle color={'dark'} slot="end"></IonInputPasswordToggle>
                                        </IonInput>
                                        
                                        <IonNote>By clicking the "Create My Account" button, you are signifying your agreement to the following SoloWise policies. Please open and read each of these policy links:</IonNote>
                                        <ul>
                                            <li className='link' id='privacyLink'><Link to={'/privacy-policy'} dir='forward'>Privacy Policy</Link></li>
                                            <li className='link' id='termsLink'><Link to={'/terms-conditions-policy'} dir='forward'>Terms and Conditions of Use Policy</Link></li>                                            
                                        </ul>
                                        
                                        <IonButton 
                                            className='ion-margin-bottom ion-margin-top' 
                                            color={disableSubmit ? 'primary' : 'secondary'}
                                            type='submit' 
                                            expand='block' 
                                            disabled={disableSubmit}
                                            ref={signupBtn}>
                                                Create My Account 
                                                <IonIcon icon={personCircleOutline} slot='end'></IonIcon>
                                        </IonButton>
                                        
                                        {/*<p className='ion-text-center'><Link to="/login">Log-in to an existing account</Link></p>*/}
                                    </form>
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>  
                </IonGrid>  
            </IonContent>
        </IonPage>
    );
};

export default Register;